import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOriginDestinationRateQuickInfo extends Layout {
    panelContent: Panel;
    sourceOriginDestinationRate: DataSource;
    textboxDescription: Textbox;
    textboxRateId: Textbox;
}
